// The API explains why it rejected an edit (a superseded family version, a missing owner role);
// a generic toast hid that and made every rejection look like the same bug.
export const getResultUpdateErrorMessage = (error: unknown, fallbackMessage: string): string => {
  const apiError = error as { status?: unknown; data?: { detail?: unknown } } | null;
  if (apiError?.status === 403) return "You don't have permission to edit this response";
  const detail = apiError?.data?.detail;
  return typeof detail === "string" && detail ? detail : fallbackMessage;
};
